import React, { Component } from "react";
import GridBlock from "./gridBlock";

//stories
import Story1 from "../../Assets/Images/ourMinistries/Publications/Stories/0.jpg";
import Story2 from "../../Assets/Images/ourMinistries/Publications/Stories/1.jpg";

const news = {
  0: {
    title: "救灾赈灾 跨州奔波 卫理志工展现“大马一家” - 暖势力 - 最新文章 | 星洲网 Sin Chew Daily",
    link: "https://www.sinchew.com.my/20220117/%e6%9a%96%e5%8a%bf%e5%8a%9b-%e5%8d%ab%e7%90%86%e5%85%ac%e4%bc%9a%e8%b5%88%e7%81%be/",
    image: "https://www.sinchew.com.my/wp-content/uploads/2022/01/e69a96e58abfe58a9b-e58dabe79086e585ace4bc9ae8b588e781be-6_marked1642408959-2048x1365.jpg",
  },
  1: {
    title: "卫理救援赈灾事工　发动《一家一个食物箱》筹款活动 | 中马 | 地方 | 東方網 馬來西亞東方日報 (orientaldaily.com.my)",
    link: "https://www.orientaldaily.com.my/news/central/2021/07/02/421897",
    image: "https://media5.orientaldaily.com.my/storage/resize_cache/images/uploads/news-cover/2021/JULY_2021/20210702/3ab7ac5e-96c8-491e-92ec-45098c1d788a.jpg/8431b3b2f5c3acde23c1e7c38e68d083.jpg",
  },
  2: {
    title: "◤行动管制◢ 卫理公会救援赈灾事工 2万套PPE 分发全马25医院 | 中國報 China Press",
    link: "https://www.chinapress.com.my/20200422/%E2%97%A4%E8%A1%8C%E5%8A%A8%E7%AE%A1%E5%88%B6%E2%97%A2-%E5%8D%AB%E7%90%86%E5%85%AC%E4%BC%9A%E6%95%91%E6%8F%B4%E8%B5%88%E7%81%BE%E4%BA%8B%E5%B7%A5-2%E4%B8%87%E5%A5%97ppe-%E5%88%86%E5%8F%91%E5%85%A8/",
    image: "https://www.chinapress.com.my/wp-content/uploads/2020/04/200423CMKfb54b-CR200422YKCB01-Methodist-Crisis-Relief-And-Development-Donate-PPE.jpg",
  },
  3: { title: "“公益”和治友德向马来西亚卫理公会救援赈灾事工捐赠抗疫物资_腾讯新闻 (qq.com)", link: "https://new.qq.com/omn/20201029/20201029A027YR00.html", image: "https://inews.gtimg.com/newsapp_bt/0/12687034553/1000" },
  4: { title: "疫情报道 | CAC Methodist", link: "https://www.methodist.org.my/%E7%96%AB%E6%83%85%E6%8A%A5%E9%81%93/", image: "https://www.methodist.org.my/wp-content/uploads/2020/03/mcrd_snippet.jpeg" },
  5: {
    title: "◤行动管制◢ 卫理公会救援赈灾事工 2万套PPE 分发全马25医院 | 中國報 China Press",
    link: "https://www.chinapress.com.my/20200422/%E2%97%A4%E8%A1%8C%E5%8A%A8%E7%AE%A1%E5%88%B6%E2%97%A2-%E5%8D%AB%E7%90%86%E5%85%AC%E4%BC%9A%E6%95%91%E6%8F%B4%E8%B5%88%E7%81%BE%E4%BA%8B%E5%B7%A5-2%E4%B8%87%E5%A5%97ppe-%E5%88%86%E5%8F%91%E5%85%A8/",
    image: "https://www.chinapress.com.my/wp-content/uploads/2020/04/200423CMKfb54b-CR200422YKCB01-Methodist-Crisis-Relief-And-Development-Donate-PPE.jpg",
  },
  6: {
    title: "卫理救援赈灾事工　发动《一家一个食物箱》筹款活动 | 中马 | 地方 | 東方網 馬來西亞東方日報 (orientaldaily.com.my)",
    link: "https://www.orientaldaily.com.my/news/central/2021/07/02/421897",
    image: "https://media5.orientaldaily.com.my/storage/resize_cache/images/uploads/news-cover/2021/JULY_2021/20210702/3ab7ac5e-96c8-491e-92ec-45098c1d788a.jpg/8431b3b2f5c3acde23c1e7c38e68d083.jpg",
  },
};

const stories = {
    0: {title:"灾难中的故事",image:Story1, link: "/Ministries/Stories/0"},
    1: {title:"憶水災 訴心聲 Hulu Langat災民有話說",image:Story2, link: "/Ministries/Stories/1"},
};

const videos = {
    0: {title:"卫理救援赈灾事工简介（2分钟版）MCRD intro (2min Ver)",image:"http://i3.ytimg.com/vi/teF1YdbyPMg/hqdefault.jpg", link: "https://www.youtube.com/watch?v=teF1YdbyPMg"},
    1: {title:"2021年末水灾救援行动记录",image:"http://i3.ytimg.com/vi/gYYtpK6k-Zg/hqdefault.jpg", link: "https://www.youtube.com/watch?v=gYYtpK6k-Zg"},
    2: {title:"爱多一点点A little Bit More Love》MV",image:"http://i3.ytimg.com/vi/slU0g4jMvs4/hqdefault.jpg", link: "https://www.youtube.com/watch?v=slU0g4jMvs4"},
    3: {title:"《希望长存》之食物援助特辑",image:"http://i3.ytimg.com/vi/udEbbZVBR9c/hqdefault.jpg", link: "https://www.youtube.com/watch?v=udEbbZVBR9c"},
    4: {title:"MCRD 圣诞信息",image:"http://i3.ytimg.com/vi/oVRK44rnwfY/hqdefault.jpg", link: "https://www.youtube.com/watch?v=oVRK44rnwfY"},
    5: {title:"Our Story - Children From Refugee Learning Center",image:"http://i3.ytimg.com/vi/nyOWYTk02K4/hqdefault.jpg", link: "https://www.youtube.com/watch?v=nyOWYTk02K4"},
    6: {title:"Our Story - Volunteer Sister Lin",image:"http://i3.ytimg.com/vi/0NR-pwT9L5s/hqdefault.jpg", link: "https://www.youtube.com/watch?v=0NR-pwT9L5s"},
    7: {title:"What MCRD done in past few year...",image:"http://i3.ytimg.com/vi/klq9svGs7ac/hqdefault.jpg", link: "https://www.youtube.com/watch?v=klq9svGs7ac"},
    8: {title:"\“Kami Ada Untukmu\" MV",image:"http://i3.ytimg.com/vi/GjAVVEjibEk/hqdefault.jpg", link: "https://www.youtube.com/watch?v=GjAVVEjibEk"},
    9: {title:"《我们这里还有衣》词/曲 黄世豪（豪哥） 唱 豪哥、Angela",image:"http://i3.ytimg.com/vi/cOGeM9689Ms/hqdefault.jpg", link: "https://www.youtube.com/watch?v=cOGeM9689Ms"},
    10: {title:"2019 Asia Christian Crisis Relief Conference Highlight 2019年亚洲基督教救援赈灾研讨会片段回顾",image:"http://i3.ytimg.com/vi/h8fNYRSOUzY/hqdefault.jpg", link: "https://www.youtube.com/watch?v=h8fNYRSOUzY"},
    11: {title:"MCRD 5K Charity Run 2018 \"Your Love Their Hope\"",image:"http://i3.ytimg.com/vi/hTU4dSq42WU/hqdefault.jpg", link: "https://www.youtube.com/watch?v=hTU4dSq42WU"},
};

/*const stories = {
    storiesTitle: storiesImage,
};

const videos = {
    videosTitle: videosLink,
};*/
class GridLayout extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div className="grid-layout">{this.fetchGridLayout()}</div>;
  }
  fetchGridLayout = () => {
    let layout = [];
    switch (this.props.publicationsNav) {
      default:
        console.log("publications undefined!");
        break;
      case "news":
        for (var i = 0; i < Object.keys(news).length; i++) {
          layout.push(<GridBlock type="rawLink" title={news[i].title} link={news[i].link} image={news[i].image} />);
        }
        return layout;
      case "stories":
        for (var i = 0; i < Object.keys(stories).length; i++) {
          layout.push(<GridBlock type="routeLink" updateScrollPos={this.props.updateScrollPos} title={stories[i].title} link={stories[i].link} image={stories[i].image} />);
        }
        return layout;
      case "videos":
        for (var i = 0; i < Object.keys(videos).length; i++) {
            layout.push(<GridBlock type="rawLink" title={videos[i].title} link={videos[i].link} image={videos[i].image} />);
          }
          return layout; 
    }
  };
}
export default GridLayout;
